// removed by extract-text-webpack-plugin
module.exports = {"block":"yFpWHLvdueVSiNRcvskTY","block-content":"_26YbVBCQdaQFJjWmio5U8N","list-content":"_3KJKKM_3-CqNcItlYAbQyz","heading":"_3fiVLDtQUNUGexbuPuCKtO","text":"_1js0YCMgllmy6sKoTQt3L4","zebra":"_3VzO1IGUKqiTA_YqzZHBze","yellow":"eU0nF129dIiLApTcTOr_9","darkgray":"_2dba2iB6381qrCqtaGf0f8","list":"OI9MkGIZKZTKaRpYYVEY9","listItem":"_1DNwcvUskKal0KOhTDACkk","icon":"msRb1O-RWjBDDQ0SEQf7N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupedLinksBlock/GroupedLinksBlock.module.scss
// module id = 772
// module chunks = 0